import { TableQuery } from "../../common/models";

export type InterventionState =
  | "Planned"
  | "Running"
  | "WaitingToSignature"
  | "WaitingToConfirm"
  | "Completed"
  | "Cancelled"
  | "DepartureStarted";

export const InterventionStateArray: InterventionState[] = [
  "Planned",
  "DepartureStarted",
  "Running",
  "WaitingToSignature",
  "WaitingToConfirm",
  "Completed",
  "Cancelled",
];

export interface CustomerPortalIntervention {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  modified: string;
  externalId?: string | null;
  /** @format uuid */
  orderId: string;
  orderCode: string;
  categoryName: string;
  ownerName: string;
  state: InterventionState;
  primaryAssigneeName: string;
  /** @format date */
  day: string;
  /** @format date-time */
  startedAt?: string | null;
  /** @format date-time */
  endedAt?: string | null;
  assignations: CustomerPortalInterventionAssignation[];
  oneLinerAddress: string;
  orderCategoryName?: string | null;
}

export interface CustomerPortalInterventionAssignation {
  /** @format uuid */
  userId: string;
  fullName: string;
  /** @format date-time */
  plannedStart: string;
  /** @format date-time */
  plannedEnd: string;
}

export interface InterventionTableQuery extends TableQuery {
  categoryId?: string | null;
  orderId?: string | null;
  daysInFuture?: number;
  daysInPast?: number;
  state?: string | null;
}
